import { updateMenuButton } from './utils/handleNavigation';
import { headerSearchBarFix, updateContentMargin } from './utils/utils';

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

// Customize Sign Up
function modifySignup() {
  const signupWidget = $('.emailSignup');
  const inputField = signupWidget.find('.emailInputField');
  const submitButton = signupWidget.find('.emailInputSubmit');
  signupWidget.find('.emailSignupText').replaceWith(`
    <div class="emailSignupTextContainer">       
      <h3>don’t miss this opportunity to join our email club now!</h3>   
      <p>Don’t be left behind! Sign up today for the latest entertainment and live music updates and get them delivered to your inbox!</p>     
    </div>`);
  $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');
  inputField
    .find('.inputFieldTextbox')
    .val('')
    .attr('placeholder', 'Email Address')
    .attr('aria-label', 'Email address');
  submitButton.find('.emailSubmitButton').text('Subscribe');
}

// Show only the first 3 letters of the month in the countdown date
function countdownDatesFormat() {
  const dateText = $('#eventDates').text();
  const firstWord = dateText.split(' ')[0];
  const shortenedMonth = firstWord.substring(0, 3);
  $('#eventDates').text(dateText.replace(firstWord, shortenedMonth));
}

// Customize Ticket Button
function customizeTicketButton() {
  $('.ticket')
    .removeClass('ticket')
    .addClass('custom-ticket')
    .empty()
    .append('<span class="ticket-icon"></span><span class="ticket-text">Buy Tickets</span>');
  $('.mobile-menu-ticket-btn').text('Buy Tickets');
}

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search Website...');
  updateMenuButton();
  fixFeatureButton();
  modifySignup();
  customizeTicketButton();
});

$(globalThis).on('load', function () {
  updateContentMargin();
  setTimeout(countdownDatesFormat, 1000);
});
